import { render, staticRenderFns } from "./editLocation.vue?vue&type=template&id=4c40cb90&scoped=true&"
import script from "./editLocation.vue?vue&type=script&lang=js&"
export * from "./editLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40cb90",
  null
  
)

export default component.exports